import _ from "lodash"
import I18n from "@helper/i18nInstance"

export const NUM_PALLETTES = 11

const ALL_HAPPY_FACES = [0, 1, 2, 3, 4, 5]
const RESPECTFUL_HAPPY_FACES = [1, 3, 5]

export const NUM_SAD_FACES = 6

export const NUM_GOOD_HEADLINES = 6
export const NUM_BAD_HEADLINES = 6

export const getRandomHappyFaceIndex = (onlyRespectfulIcons?: boolean) => {
  return _.shuffle(onlyRespectfulIcons ? RESPECTFUL_HAPPY_FACES : ALL_HAPPY_FACES)[0]
}

export const getRandomSadFaceIndex = () => {
  return _.random(0, NUM_SAD_FACES - 1)
}

export const getRandomGoodHeadline = () => {
  return I18n.t(`quiz.question_eval.good${_.random(0, NUM_GOOD_HEADLINES - 1)}`)
}

export const getRandomBadHeadline = () => {
  return I18n.t(`quiz.question_eval.bad${_.random(0, NUM_BAD_HEADLINES - 1)}`)
}

export const onlyUseSeriousAndRespectfulIconsAndTexts = (quiz: Quiz.Api.Quiz) => {
  const keywords = ["Krebs"]
  const searchThrough = [quiz.meta.title]
  return _.some(searchThrough, (text) => {
    return _.some(keywords, (k) => {
      return text.toUpperCase().indexOf(k.toUpperCase()) > -1
    })
  })
}

const EXTRA_CONTENT_THAT_INDICATES_QUIZ_WITHOUT_RANKING: Quiz.Api.ExtraContent[] = [
  "xmas-2020",
  "no-ranking"
]

export const isRankingRelevant = (quiz?: Quiz.Api.Quiz) => {
  return !quiz?.result?.extra_content || EXTRA_CONTENT_THAT_INDICATES_QUIZ_WITHOUT_RANKING.indexOf(quiz?.result?.extra_content) === -1
}